var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area"},[_c('el-cascader',{ref:"cascader1",attrs:{"props":_vm.props,"options":_vm.areaArr},on:{"visible-change":_vm.visibleChange,"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }